module.exports = __webpack_public_path__ + "assets/60439e2d7676a59b249d94112d245b3c.jpg";